import React, { useEffect, useRef, useState } from "react";
import style from './disconnectModal.module.scss';
import Button from "../../Button/button"
import Modal from "../../Modal/Modal";
import EditChannelModal from '../../editChannelModal/editChannelModal'
import { SubmitEditChannel } from "../../../actions/APIcalls";
import toEnglishNumber from "../../../helpers/actions/toEnglishNumber";
import Cookies from "js-cookie"
import disconnectTextGenerator from '../../../helpers/actions/disconnectedText'
import utf8 from 'utf8'

const DisconnectModal = (props) => {
    const wrapperRef = useRef(null);
    const insideRef = useRef(null);

    const [scrollable, setScrollable] = useState(false)
    const [scrollProps, setScrollProps] = useState({
        prevScrollPos: 0,
        visibility: false,
    })
    const [editModal, setEditModal] = useState({
        show: false,
        email: '',
        channelId: ''
    })

    const handleScroll = () => {
        if (wrapperRef.current) {
            if (wrapperRef.current.offsetHeight < insideRef.current.clientHeight) {
                setScrollable(true)
            } else {
                setScrollable(false)
            }
        }
        if (wrapperRef.current) {
            const tmpPrevPos = scrollProps.prevScrollPos;
            const currentPos = wrapperRef.current.scrollTop;
            let tmpVisibility = scrollProps.visibility;
            if (tmpPrevPos < currentPos) {
                tmpVisibility = true;
            } else {
                tmpVisibility = false;
            }
            let tmpScrollProps = scrollProps;
            tmpScrollProps.visibility = tmpVisibility;
            tmpScrollProps.prevScrollPos = currentPos;
            setScrollProps({ ...tmpScrollProps });
        }
    }
    const parentClose = () => {
        if (props.type === "disconnected") {
            Cookies.set('disconnectedModalShow', 'true', { expires: 1 });
        }
        if (props.type === "expiredAccount" || props.type === "OneDayToExpire") {
            Cookies.set('expiredModalShow', 'true', { expires: 1 });
        }
        if (props.type === "showTelegramModal") {
            Cookies.set('showTelegramModal', 'true', { expires: 30 });
        }
        if (props.type === "updatePrices") {
            Cookies.set('updatePrices', 'true');
        }
        props.parentClose()
    }

    const submitEditChannel = async (email, newPassword) => {
        let params = {
            channelId: editModal.channelId,
            password: toEnglishNumber(newPassword),
            username: editModal.email,
            email: editModal.email
        }
        let res = await SubmitEditChannel(params)
        let channels = await props.updateChannels()
        return res;
    }

    const handleDisconnected = (type, link) => {
        Cookies.set(type, 'true', { expires: 1 });
        props.parentClose()
        window.location.href = `https://robot.mobisha.ir/${link}`;
    }


    useEffect(() => {
        if (wrapperRef.current) {
            if (wrapperRef.current.offsetHeight < insideRef.current.clientHeight) {
                setScrollable(true)

            } else {
                setScrollable(false)
            }
        }

    }, []);

    useEffect(() => {
        document.addEventListener("scroll", handleScroll, true);
        return () => {
            document.removeEventListener("scroll", handleScroll, true);
        };
    });
    return (
        <React.Fragment>
            <EditChannelModal
                show={editModal.show}
                closemodal={() => setEditModal({ ...editModal, show: false })}
                email={editModal.email}
                editchannel={submitEditChannel}
            />
            <Modal
                value={props.value}
                title={props.title}
                parentClose={() => parentClose()}
            >
                <>
                    <div>
                        {props.type === "disconnected" ?
                            <div className={style.contentWrapper}>
                                <div className={style.disconnectIcon}></div>
                                <p className={style.disconnectText}>{disconnectTextGenerator(props.props)}</p>
                                <p className={style.text}>ارتباط موبیشا با پنل شما قطع شده‌است، لطفا برای برقراری مجدد ارتباط پنل خود را ویرایش کنید.</p>
                                <div className={style.buttonPack}>
                                    <a
                                        className={style.full}
                                        onClick={() => handleDisconnected('disconnectedModalShow', 'channels')}
                                    >
                                        <Button
                                            type="solid"
                                            label="اتصال به پنل دیجی‌کالا"
                                            onclick={() => { }}

                                        />
                                    </a>
                                </div>
                            </div>
                            :
                            (props.type === 'expiredAccount' ? <div className={style.contentWrapper}>
                                <div className={style.icon}>n</div>
                                <p className={style.boldText}>!کاربر عزیز، کیف پول شما تمام شده است</p>
                                <p className={style.text}>لطفا برای فعال‌سازی مجدد، کیف پول خود را شارژ کنید.</p>
                                <div className={style.buttonPack}>
                                    <div className={style.left} id="cancelModal">
                                        <Button type="outline" label="بستن" onclick={() => {
                                            parentClose()
                                        }} />

                                    </div>
                                    <a
                                        className={style.right}
                                        onClick={() => handleDisconnected('expiredAccount', 'chargewallet')}
                                    >
                                        <Button type="solid" label="ورود به صفحه شارژ  کیف پول"
                                            onclick={() => { }} />

                                    </a>
                                </div>
                            </div>
                                :
                                (props.type === 'OneDayToExpire' ? <div className={style.contentWrapper}>
                                    <div className={style.icon}>n</div>
                                    <p className={style.boldText}>!کاربر عزیز، ۱ روز تا پایان کیف پول شما
                                        باقی مانده است</p>
                                    <p className={style.text}>برای جلوگیری از غیرفعال شدن ربات، کیف پول خود را شارژ کنید.</p>
                                    <div className={style.buttonPack}>
                                        <div className={style.left} id="cancelModal">
                                            <Button type="outline" label="بستن" onclick={() => {
                                                parentClose()
                                            }} />

                                        </div>
                                        <a
                                            className={style.right}
                                            onClick={() => handleDisconnected('expiredAccount', 'chargewallet')}
                                        >
                                            <Button type="solid" label="ورود به صفحه شارژ  کیف پول"
                                                onclick={() => { }} />
                                        </a>
                                    </div>
                                </div>
                                    :
                                    (props.type === 'showTelegramModal' ?
                                        <div className={style.contentWrapper}>
                                            <div className={style.telegramIcon}></div>
                                            <p className={style.boldText}>!ربات تلگرام موبیشا را فعال کنید</p>
                                            <p className={style.text}>برای مشاهده آخرین وضعیت محصولات فعال خود و اطلاع از تنوع‌هایی که در حین قیمت‌گذاری با مشکل مواجه شده‌اند، ربات تلگرام را فعال کنید.</p>
                                            <p className={style.telegramId}>آی‌دی ربات تلگرام: mobishabot@</p>
                                            <div className={style.buttonPack}>
                                                <div className={style.left} id="cancelModal">
                                                    <Button type="outline" label="بستن" onclick={() => {
                                                        parentClose()
                                                    }} />
                                                </div>
                                                <a
                                                    className={style.right}
                                                    href="https://t.me/mobishabot"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <Button type="solid" label="فعال‌سازی ربات تلگرام"
                                                        onclick={() => { }} />
                                                </a>
                                            </div>
                                        </div>
                                        :
                                        <div className={style.contentWrapper}>
                                            <div className={style.updateIcon}></div>
                                            <p className={style.boldText}>اطلاعیه مهم | به‌روزرسانی قیمت‌ها📢</p>
                                            <p className={style.text}>همیشه تلاش کرده‌ایم که بهترین خدمات را با قیمت‌های منصفانه ارائه دهیم و در یک سال گذشته، با وجود افزایش شدید هزینه‌ها، قیمت‌ها را ثابت نگه داشتیم. اما متأسفانه، با توجه به شرایط اقتصادی فعلی، ناچاریم تغییراتی در قیمت‌گذاری سرویس‌ها اعمال کنیم.</p>
                                            <p className={style.text}>❓ چرا این تغییر ضروری است؟</p>
                                            <p className={style.text}>🔹 افزایش نرخ دلار | هزینه‌های ما به‌طور مستقیم به نرخ ارز وابسته است، و از سال گذشته تاکنون، دلار افزایش چشمگیری داشته است. با وجود تمام تلاش‌هایمان، ادامه این روند بدون تعدیل قیمت‌ها دیگر ممکن نیست.</p>
                                            <p className={style.text}>🔹 حفظ کیفیت خدمات | برای اینکه همچنان بتوانیم سرویس‌های پایدار، سریع و باکیفیت ارائه دهیم، نیازمند سرمایه‌گذاری در زیرساخت‌ها و به‌روزرسانی مداوم هستیم.</p>
                                            <p className={style.text}>🔹 تورم و افزایش هزینه‌ها | هزینه‌های عملیاتی، سرورها، پشتیبانی و سایر موارد اساسی به‌شدت افزایش پیدا کرده‌اند، و برای ادامه فعالیت، باید این تغییرات را اعمال کنیم.</p>
                                            <p className={style.text}>📆 از چه زمانی اعمال می‌شود؟</p>
                                            <p className={style.text}>✅ از اول اسفند ماه ۱۴۰۳ این تغییرات قیمت روی پنل‌ها اعمال و قیمت‌های جدید اجرایی خواهند شد.</p>
                                            <p className={style.text}>✅ مشتریان فعلی تا تاریخ ۳۰ بهمن ماه فرصت دارند با قیمت‌های فعلی، سرویس‌های خود را تمدید کنند.</p>
                                            <p className={style.text}>🙏 قدردان همراهی شما هستیم</p>
                                            <p className={style.text}>می‌دانیم که افزایش قیمت‌ها خبر خوشایندی نیست، اما این تغییرات برای حفظ کیفیت خدمات و ادامه فعالیت ضروری است. از حمایت و درک شما بی‌نهایت سپاسگزاریم و همیشه تلاش می‌کنیم بهترین تجربه را برایتان فراهم کنیم.</p>
                                            <p className={style.text}>📩 اگر سوالی داشتید، تیم پشتیبانی ما از طریق تلگرام، پیامک و یا تماس تلفنی همیشه آماده پاسخگویی است.</p>
                                            <p className={style.text}>با احترام و قدردانی، داده‌پردازان هوشمند بامداد</p>
                                            <div className={style.buttonPack}>
                                                <div id="cancelModal">
                                                    <Button type="outline" label="بستن" onclick={() => {
                                                        parentClose()
                                                    }} />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                )
                            )
                        }
                    </div>
                    <div
                        className={!scrollProps.visibility && scrollable ? style.modalFooterScroll : style.modalFooter}>
                    </div>
                </>
            </Modal>
        </React.Fragment>
    )
}
export default DisconnectModal